<template>
  <p class="forum-search__page-buttons u-fontsize-sm">
    <button
      v-if="currentPage > 1"
      :aria-label="gettext('Previous page')"
      :disabled="state === 'loading'"
      type="button"
      class="btn btn--sm btn--dark forum-search__page-button"
      @click.prevent="$emit('page-nav', 'prev')"
    >
      <svg
        aria-hidden="true"
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 100 100"
      >
        <path d="M53 98l12-12-27-27 40 1h16V40H78l-40 1 27-27L53 2 5 50z" />
      </svg>
    </button>
    <span class="u-px-md">
      {{ pgettext('page in pagination', 'Page') }}
      <input
        id="current-page"
        v-model="currentPage"
        type="number"
        :min="1"
        :max="maxPageNum"
        class="forum-search__xs-input u-mx-xs"
        @focus="$event.target.select()"
      >
      {{ pgettext('## of ##', 'of') }}
      {{ totalPages }}
    </span>
    <button
      v-if="currentPage < totalPages"
      :aria-label="gettext('Next page')"
      :disabled="state === 'loading' || currentPage >= maxPageNum"
      type="button"
      class="btn btn--sm btn--dark forum-search__page-button"
      @click.prevent="$emit('page-nav', 'next')"
    >
      <svg
        aria-hidden="true"
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 100 100"
      >
        <path d="M47 2L35 14l27 27-40-1H6v20h16l40-1-27 27 12 12 48-48z" />
      </svg>
    </button>
    <span
      v-if="currentPage >= maxPageNum"
      class="forum-search__max-page-warning"
    >
      You have reached the max number of pages that is able to be returned for this search.<br>
      Please narrow your results by applying filters or searching for specific terminology.
    </span>
  </p>
</template>

<script>
export default {
  name: 'MessageSearchPageNav',

  props: {
    state: {
      type: String,
      default: ''
    },
    initCurrentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 1
    },
  },
  computed: {
    currentPage: {
      get() {
        return this.initCurrentPage
      },
      set(pageNum) {
        let validatedPageNum

        if (pageNum > this.totalPages || pageNum > this.maxPageNum) {
          validatedPageNum = this.maxPageNum
        } else if (pageNum < 1) {
          validatedPageNum = 1
        } else {
          validatedPageNum = pageNum
        }

        this.$emit('select-page', validatedPageNum)
        return validatedPageNum
      },
    },
    maxPageNum() {
      const maxESResults = 10000
      return Math.floor(maxESResults / this.$store.state.limit)
    }
  },
}
</script>
